import isArrayLike from './is-array-like';

var contains = function (arr, value) {
  if (!isArrayLike(arr)) {
    return false;
  }

  return arr.indexOf(value) > -1;
};

export default contains;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/contains.js
// module id = 12
// module chunks = 0